import { upperCase, upperCaseFirst } from 'change-case'

const addElementToSingleWordElements = element =>
  element.match(/[A-Z]/g).length < 2 ? `${element}Element` : element

export const getContentElementType = (type, locale = '') =>
  addElementToSingleWordElements(
    upperCaseFirst(type.replace(/(?:_|-|\/)(.)/g, (m, $1) => upperCase($1, locale))),
  )

export const getElementType = (type, locale = '') => getContentElementType(type, locale)
